import React from "react";
import type { SignUpFormData } from "@types";
import AutosuggestionInput from "../../../shared/AutosuggestionInput";
import OtherProfessionQuery from "../../../../assets/StaticQueries/OtherProfession.query";

type OtherProfessionFieldType = {
  globalProfession: string;
  formData: SignUpFormData;
  setFormData: React.Dispatch<React.SetStateAction<SignUpFormData>>;
};

const OtherProfessionField: React.FC<OtherProfessionFieldType> = ({
  setFormData,
  formData,
  globalProfession,
}) => {
  const autosuggestionList = OtherProfessionQuery();

  const onSetValue = (val: string) => {
    setFormData(prevState => ({
      ...prevState,
      otherProfession: {
        ...prevState.otherProfession,
        value: val.toLowerCase(),
        isUpdated: true,
      },
    }));
  };

  const onSetError = ({ hasError }: { hasError: boolean }) => {
    setFormData(prevState => ({
      ...prevState,
      otherProfession: {
        ...prevState.otherProfession,
        validation: {
          ...prevState.otherProfession.validation,
          hasError,
        },
      },
    }));
  };

  return (
    <>
      {globalProfession === "7" && (
        <AutosuggestionInput
          errorMsg="Please enter a valid profession."
          label="If other, please enter the title of your profession."
          listItems={autosuggestionList as AutosuggestionInput.ListItem[]}
          onSetError={onSetError}
          onSetValue={onSetValue}
          externalError={formData.otherProfession.validation.hasError}
        />
      )}
    </>
  );
};

export default OtherProfessionField;
